import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import jojoAccount from '@jojo/account-sdk';
import dayjs from 'dayjs';
import { jojoAccountConfig } from '@/const';
import { newPromptFunc } from '@/modules/landing/CourseSelection/methods/help';
import { sensClickInitiative, sensElementView } from '@/utils/sensors';
jojoAccount.config(jojoAccountConfig);
export var userPopoutModal = function userPopoutModal() {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      // 撤销申请
      jojoAccount.popupLogout({
        showModal: false
      }).then(function (resp) {
        var _a, _b, _c;

        if (((_a = resp.data) === null || _a === void 0 ? void 0 : _a.accountState) === 'WAIT_CANCELLATION') {
          var originalDate = dayjs((_b = resp === null || resp === void 0 ? void 0 : resp.data) === null || _b === void 0 ? void 0 : _b.createTime); // 解析为dayjs对象

          var newDate = originalDate.add(((_c = resp === null || resp === void 0 ? void 0 : resp.data) === null || _c === void 0 ? void 0 : _c.cancelPeriod) || 15, 'day'); // 核心：增加15天

          newPromptFunc({
            title: '温馨提示',
            content: "\u60A8\u7684\u8D26\u53F7\u5DF2\u4E8E".concat(originalDate.format('M月D日'), "\u7533\u8BF7\u6CE8\u9500\uFF0C\u5C06\u5728").concat(newDate.format('M月D日'), "\u6B63\u5F0F\u5931\u6548\u3002\u82E5\u7EE7\u7EED\u64CD\u4F5C\uFF0C\u7CFB\u7EDF\u5C06\u81EA\u52A8\u64A4\u56DE\u6CE8\u9500\u7533\u8BF7\uFF0C\u60A8\u7684\u8D26\u53F7\u53EF\u7EE7\u7EED\u6B63\u5E38\u4F7F\u7528\u3002"),
            btnText: '撤回注销并继续',
            onCenterBtnClick: function onCenterBtnClick(dom) {
              return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      sensClickInitiative({
                        $element_name: '撤回注销申请弹窗_撤回注销点击',
                        activity_label: '投放'
                      });
                      return [4
                      /*yield*/
                      , jojoAccount.withdrawLogout()];

                    case 1:
                      _a.sent();

                      dom === null || dom === void 0 ? void 0 : dom.remove();
                      return [2
                      /*return*/
                      ];
                  }
                });
              });
            }
          });
          sensElementView({
            c_element_name: '撤回注销申请弹窗显示',
            activity_label: '投放'
          });
        }
      });
      return [2
      /*return*/
      ];
    });
  });
};